var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "error-box" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-sm-12 text-sm-center" }, [
          _c("h1", [_vm._v("500")]),
          _vm._v(" "),
          _c("h5", [_vm._v("Ваш браузер не поддерживается")]),
          _vm._v(" "),
          _c("div", { staticClass: "alert alert-info" }, [
            _vm._v(
              "\n        Просим Вас использовать интернет браузеры из списка:\n        "
            ),
            _c("p", [_c("strong", [_vm._v("Chrome")])]),
            _vm._v(" "),
            _c("p", [_c("strong", [_vm._v("Safari")])]),
            _vm._v(" "),
            _c("p", [_c("strong", [_vm._v("Opera")])]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }